import React, { createContext, useState, useContext } from "react";
import { Alert } from "flowbite-react";
import { HiInformationCircle } from "react-icons/hi";

const ErrorContext = createContext();

const typeToColor = {
  error: "warning",
  info: "info",
  success: "success",
};

export const ErrorProvider = ({ children }) => {
  const [alerts, setAlerts] = useState([]);
  const maxAlerts = 4;

  const addAlert = (newAlert) => {
    setAlerts((prevAlerts) => {
      // Ensure FIFO principle and max 4 alerts
      let updatedAlerts = [...prevAlerts, newAlert];
      if (updatedAlerts.length > maxAlerts) {
        updatedAlerts = updatedAlerts.slice(1); // Remove the oldest alert
      }
      return updatedAlerts;
    });

    setTimeout(() => {
      setAlerts((prevAlerts) =>
        prevAlerts.filter((alert) => alert !== newAlert),
      );
    }, 5000);
  };

  const addError = (error) => {
    const newAlert = { type: "error", message: error };
    addAlert(newAlert);
  };

  const addInfo = (message) => {
    const newAlert = { type: "info", message: message };
    addAlert(newAlert);
  };

  const clearErrorHandler = (index) => {
    setAlerts((prevAlerts) => {
      let newAlerts = [...prevAlerts];
      newAlerts.splice(index, 1);
      return newAlerts;
    });
  };

  const clearAllErrorsHandler = () => {
    setAlerts([]);
  };

  const setErrors = (errors) => {
    setAlerts(errors.map((error) => ({ type: "error", message: error })));
    setTimeout(() => {
      setAlerts((prevAlerts) =>
        prevAlerts.filter(
          (alert) =>
            !(alert.type === "error" && errors.includes(alert.message)),
        ),
      );
    }, 5000);
  };

  const setErrorList = (errors) => {
    const newAlert = { type: "error", format: "list", content: errors };
    setAlerts([newAlert]);
    setTimeout(() => {
      setAlerts((prevAlerts) =>
        prevAlerts.filter((alert) => alert !== newAlert),
      );
    }, 5000);
  };

  return (
    <ErrorContext.Provider
      value={{
        addInfo,
        alerts,
        addError,
        clearErrorHandler,
        clearAllErrorsHandler,
        setErrors,
        setErrorList,
      }}
    >
      <div className="sticky top-4 z-50 p-0">
        {alerts.map((alert, index) => (
          <Alert
            key={index}
            className="mx-4 mb-4"
            onDismiss={() => clearErrorHandler(index)}
            color={typeToColor[alert.type]}
            icon={HiInformationCircle}
          >
            {alert.format === "list" ? (
              <div>
                <span className="font-medium">Error alert!</span>
                <ul>
                  {alert.content.map((error, index) => (
                    <li key={index}>{error}</li>
                  ))}
                </ul>
              </div>
            ) : (
              <>
                <span className="font-medium">Info alert!</span> {alert.message}
              </>
            )}
          </Alert>
        ))}
      </div>
      {children}
    </ErrorContext.Provider>
  );
};

export const useError = () => {
  return useContext(ErrorContext);
};
